import { render, staticRenderFns } from "./DepositorAliasModal.vue?vue&type=template&id=29cf7a65"
import script from "./DepositorAliasModal.vue?vue&type=script&lang=js"
export * from "./DepositorAliasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports